<script setup lang="ts">
// konfetti Gutscheine supplier ID
import { GtmItemListId } from '~/composables/useKftGtm/types'
import { useGiftcardItemListSchema } from '~/composables/schemaOrg/useGiftcardItemListSchema'

const supplierID = 'z38lrx'
const eventsPath = 'v1/store/events'
const supplierEventsParams = `?limit=-1&include=supplier,categories&search=supplier_id:${supplierID};hasEvent:false&orderBy=created_at`
const { data: giftcardEventsData } = await useKftApiFetch(
  `${eventsPath}${supplierEventsParams}`,
  { transform: transformToAlgoliaEvent }
)
const {
  title = '',
  subtitle = '',
  spaciousHeader = false,
  isSlider = false,
  showMoreInTitle = false,
  expandable = false,
  maxRows = undefined,
  maxProducts = undefined,
  isGiftcardSummary = false,
} = defineProps<{
  title?: string
  subtitle?: string
  /** Widens the header-to-grid gap — see `ProductShowcase.spaciousHeader`. */
  spaciousHeader?: boolean
  /** Horizontal rail at every breakpoint instead of a grid from `md:` up. */
  isSlider?: boolean
  /** Show "show more" beside the title — see `ProductShowcase.showMoreInTitle`. */
  showMoreInTitle?: boolean
  /** "Show more" reveals capped products — see `ProductShowcase.expandable`. */
  expandable?: boolean
  /** Caps the showcase to whole grid rows — see `ProductShowcase.maxRows`. */
  maxRows?: number
  /** Hard cap on rendered products — see `ProductShowcase.maxProducts`. */
  maxProducts?: number
  /**
   * Set on /giftcard/, the summary page of these giftcards: every giftcard is
   * rendered and marked up as an ItemList. A grid on every breakpoint shows
   * the first two desktop rows, with a toggle below it for the rest, instead
   * of a "show more" linking back to the same page.
   */
  isGiftcardSummary?: boolean
}>()

const SUMMARY_COLLAPSED_COUNT = 8

if (isGiftcardSummary) useGiftcardItemListSchema(giftcardEventsData)
</script>
<template>
  <div>
    <ProductShowcase
      data-test-id="giftcard-events-section"
      :products="giftcardEventsData"
      image-loading="eager"
      title-h-class="section-title"
      :is-slider="isSlider"
      :is-mobile-slider="!isSlider && !isGiftcardSummary"
      :collapsed-count="
        isGiftcardSummary && !isSlider ? SUMMARY_COLLAPSED_COUNT : undefined
      "
      :button-link="isGiftcardSummary ? undefined : '/giftcard/'"
      :show-more-in-title="showMoreInTitle"
      :expandable="expandable && !isGiftcardSummary"
      :max-rows="isGiftcardSummary ? undefined : maxRows"
      :max-products="isGiftcardSummary ? undefined : maxProducts"
      :title="title"
      :subtitle="subtitle"
      :spacious-header="spaciousHeader"
      :gtm-item-list-id="GtmItemListId.GeneralPageGiftcardEvents"
      :is-duration-visible="false"
    />
  </div>
</template>
